import { render, staticRenderFns } from "./2021-3-8.vue?vue&type=template&id=9ab34512&scoped=true&"
import script from "./2021-3-8.vue?vue&type=script&lang=ts&"
export * from "./2021-3-8.vue?vue&type=script&lang=ts&"
import style0 from "./2021-3-8.vue?vue&type=style&index=0&id=9ab34512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab34512",
  null
  
)

export default component.exports